<template>
  <Card class="layout-card">
      <div style="margin-bottom: 10px;">
          <div class="search-form">
              <Select v-model="searchForm.metric" multiple placeholder="请选择指标" :max-tag-count="1" @on-change="changeMetric" label-in-value filterable style="width: 24%;">
              <template #prefix>
                <a style="font-size: 12px;padding: 0 5px;white-space: nowrap;" @click="(e)=>{
                  e.preventDefault()
                  e.stopPropagation();  
                  if(metric.length===homeData.length){
                    searchForm.metric=[]
                    changeMetric([])
                  }
                  else{
                    const data = homeData.map(i=>i.value) 
                    searchForm.metric = data
                    changeMetric(homeData)
                  }
                  
                }">{{ metric.length===homeData.length?'清空':'全选' }}</a>
              </template>
                <Option v-for="(i,index) in homeData" :key="index" :value="i.value">{{ i.label }}</Option>
              </Select>
              <Select v-model="searchForm.channel" placeholder="请选择聚合渠道" clearable style="width: 24%;" @on-change="findChannels" :disabled="channelTag">
                <Option value="facebook">facebook</Option>
                <Option value="google">google</Option>
                <Option value="tiktok">tiktok</Option>
                <Option value="other">其他</Option>
              </Select>
              <Select v-model="channels" :disabled="channelTag" placeholder="请选择渠道" clearable filterable style="width: 24%;" :max-tag-count="1" multiple @on-change="searchForm.channels = $event">
                <template #prefix>
                  <a style="font-size: 12px;padding: 0 5px;white-space:nowrap" @click="(e)=>{
                    e.preventDefault()
                    e.stopPropagation();  
                    if(channels.length===cloneChannels.length){
                      searchForm.channels=[]
                      changeChannels([])
                    }
                    else{
                      const data = [...cloneChannels]
                      $set(searchForm,'channels',data)
                      changeChannels(data)
                    }
                    
                  }">{{ channels.length!==cloneChannels.length?'全选':'清空' }}</a>
                </template>
                <Option v-for="(i,index) in cloneChannels" :key="index" :value="i">{{ i }}</Option>
              </Select>
              <!-- <Select v-model="searchForm.os" placeholder="请选择os" clearable filterable>
                <Option v-for="(i,index) in searchOptions.os" :key="index" :value="i">{{ i }}</Option>
              </Select>
              <Select v-model="searchForm.country" placeholder="请选择国家/地区" clearable filterable>
                <Option v-for="(i,index) in searchOptions.country" :key="index" :value="i">{{ i }}</Option>
              </Select> -->
              <DatePicker :editable="false" format="yyyy-MM-dd" type="daterange" style="width: 24%;" placeholder="请选择日期" :value="listDate" @on-change="getListDate" clearable></DatePicker>
              
              <Select v-model="searchForm.timeZone" placeholder="请选择时区"  style="width: 24%;">
                <Option :value="8">东八区</Option>
                <Option :value="-8">西八区</Option>
              </Select>
              <Select v-model="campaign" placeholder="请选择广告系列" filterable :max-tag-count="1" multiple style="width: 40%;" :disabled="!searchOptions.campaign.length" @on-change="searchForm.adsCampaign = $event">
                <template #prefix>
                <a v-show="searchOptions.campaign.length" style="font-size: 12px;padding: 0 5px;white-space:nowrap" @click="(e)=>{
                  e.preventDefault()
                  e.stopPropagation();  
                  if(campaign.length===searchOptions.campaign.length){
                    searchForm.adsCampaign=[]
                    changeCampaign([])
                  }
                  else{
                    const data = [...searchOptions.campaign]
                    $set(searchForm,'adsCampaign',data)
                    changeCampaign(data)
                  }
                  
                }">{{ campaign.length!==searchOptions.campaign.length?'全选':'清空' }}</a>
              </template>
                <Option v-for="(i,index) in searchOptions.campaign" :key="index" :value="i">{{ i }}</Option>
              </Select>
              <Button  type="primary" @click="getData()">查询</Button>
              <Button style="width: auto;" @click="handleReset()">重置</Button>
              <Button style="width: auto;" type="warning" @click="handleExport()">导出</Button>
          </div>
      </div>
      <div>
      <Table border :data="tableData" :columns="column" v-if="columns.length>1" :loading="showTable" show-summary :summary-method="handleSummary" @on-sort-change="test">
          <Pages slot="footer" :page="page" :func="getTable" :pArr="[31,50]"></Pages>
      </Table>
      <div v-else style="text-align: center;font-size: 18px;padding: 20px 0">请选择查询项</div>
      </div>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getDictionaryList } from '@/api/dictionary'
import { getDataInit, getTableDataColor as getTableData } from '@/api/data'
import dayjs from 'dayjs'
import home, { homeData } from '.'
import { utils, writeFile } from 'xlsx'
import { cloneDeep } from 'lodash'
export default {
  name:'dataColor',
components: {
  Pages
},
data() {
  return {
    homeData,
    editVisible:false,
    form:{},
    channelTag:false,
    searchForm:{
      metric: [],
      channels: [],
      channel: '',
      adsCampaign: [],
      timeZone: -8
    },
    listDate:[],
    submitLoading:false,
    showTable:false,
    page: {
      current: 1,
      size: 31,
      total: 0
    },
    metric: [],
    tableData: [],
    column: [],
    realData: [],
    campaign: [],
    channels: [],
    orders: {
      key: '',
      order: ''
    },
    cloneChannels: [],
    searchOptions: {
      campaign: [],
      channels: [],
      country: [],
      os: []
    }
  }
},
computed:{
  buttonMenu() {
    const li = this.$store.getters.getMenuRules('data')
    const obj = {}
    li.forEach(i => {
      obj[i.menuPath] = true
    })
    return obj
  },
  columns(){
    const li = []
    const res = this.metric.map(i=>{
      return {
        title: i.label,
        key: i.value.split(',')[1],
        width: i.width?i.width:(i.label.length>5?140:100),
        needCalc:i.needCalc,
        calc: i.calc,
        sortable: i.sortable,
        render: i.render
      }
      
    })
    // console.log(res);
    // if(this.searchForm.country){
    //   li.push({
    //     title: '国家/地区',
    //     key: 'countryCode	',
    //   width: 100
    // })
    // }
    // if(this.searchForm.os){
    //   li.push({
    //     title: 'OS',
    //   width: 100,
    //     key: 'os'
    //   })
    // }
    // if(this.searchForm.channel&&this.searchForm.channel.length){
    //   li.push({
    //     title: '渠道',
    //     width: 130,
    //     key: 'channel'
    //   })
    // }
    if(this.searchForm.adsCampaign&&this.searchForm.adsCampaign.length){
      li.push({
        title: '广告系列',
        width: 500,
      sortable: true,
        key: 'campaign'
      })
    }
    return [{
      title: '日期',
      key: 'createTime',
      sortable: true,
      fixed: 'left',
      width: 100
    },...li
    ,...res].map(i=>({
      ...i,
      resizable: true,
    }))
  }
},
methods:{
  test({column,key,order}){
    console.log(key,order);
    
    this.orders = {
      key,
      order
    }
    this.getTable()
  },
  handleExport() {
      const headerRow = this.column.map(header => header.title);
      const dataRows = this.realData.map(item => {
        return this.column.map(header => {
          // 处理嵌套属性（如：'user.address.city'）
          const prop = header.key
          return item[prop]?(header.render?Number(item[prop]*100).toFixed(2)+'%':item[prop]) : 0; // 空值处理
        });
      });
      const worksheetData = [
        headerRow,
        ...dataRows
      ];
      const worksheet = utils.aoa_to_sheet(worksheetData);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, "数据总览");

      // 6. 生成Excel文件并下载
      writeFile(workbook, "数据总览.xlsx");
    },
    findChannels(e){
    this.cloneChannels = []
    this.searchForm.channels = []
    this.channels = []
    if(e) getDictionaryList({dictTopic: 'ADS_COST_CHANNEL',dictName:e}).then(r=>{
      if(r.data.records)
      this.cloneChannels = r.data.records[0].dictValue.split(',')
    })
    else this.cloneChannels = [...this.searchOptions.channels]
  },
  handleSummary({columns,data}){
    
    const res = {}
    const sums = {}
    columns.forEach((column,index)=>{
      const key = column.key
      if(!index){
        sums[key] = {
          key,
          value: '合计'
        }
        return
      }
      const values = this.realData.map(i=>Number(i[key]))
      if(!column.needCalc){
        if (!values.every(value => isNaN(value))){
          const v = values.reduce((pre,next)=>{
            const value = Number(next)
            if(!isNaN(value)){
              return pre + next
            }else{
              return pre
            }
          },0)
          sums[key] = {
            key,
            value: Number(v.toFixed(2))
          }

        }else{
          sums[key] = {
            key,
            value: '-'
          }
        }
      }
    })
    
    columns.forEach((column)=>{
      const key = column.key
      
      if(column.needCalc){
        const vs1 = this.realData.map(i=>Number(i[column.calc.data[0]])).reduce((p,n)=>!isNaN(Number(n))? p+n: p,0)
        const vs2 = this.realData.map(i=>Number(i[column.calc.data[1]])).reduce((p,n)=>!isNaN(Number(n))? p+n: p,0)
        const value = vs1/vs2
        sums[key] = {
          key,
          value: vs2&&value?column.calc.unit?Number((value*100).toFixed(2))+'%':Number(value.toFixed(2)):'-'
        }
      }else{
        return
      }
    })
    
    return sums
    
  },
  changeMetric(e){
    const values = e.map(i=>i.value)
    localStorage.setItem('metric',JSON.stringify(values))
    this.metric = homeData.filter(i=>values.indexOf(i.value)>-1)
  },
  changeCampaign(e){
    this.campaign = e
  },
  changeChannels(e){
    this.channels = e
  },
  getListDate(data) {
      this.listDate = data
      this.searchForm.startDate = data[0]
      this.searchForm.endDate = data[1]
    },
  getData() {
    this.showTable=true
    
    this.column = this.columns
    let channel = ''
    if(this.searchForm.channels&&this.searchForm.channels.length){
      channel = [...this.searchForm.channels].map(i=>i.split(',')[0]).join(',')
    }else{ 
      if(this.searchForm.channel) channel = this.searchForm.channel
    }
    getTableData({
      ...this.searchForm,
      channel,
      channels: undefined,
      metric: this.searchForm.metric&&this.searchForm.metric.length?[...this.searchForm.metric.map(i=>i.split(',')[0])]:null,
      adsCampaign: this.searchForm.adsCampaign&&this.searchForm.adsCampaign.length?[...this.searchForm.adsCampaign].map(i=>i.split(',')[0]).join(','):null
    }).then(({ data }) => {
      this.realData = data
      this.page.total = data.length
      
      if(process.env.NODE_ENV === 'development'){
  //     this.realData = [
  //     {
  //     "createTime": "2025-05-23",
  //     "countryCode": null,
  //     "channel": null,
  //     "os": null,
  //     "campaign": null,
  //     "cost": 7226.63,
  //     "activation": 1556,
  //     "registrationCount": null,
  //     "activationCost": 4.64,
  //     "registrationCost": null,
  //     "firstRechargeCount": 175,
  //     "firstCostCount": 41.3,
  //     "firstRechargeCost": 4088.67,
  //     "firstPayRate": 0.11,
  //     "firstARPU": 23.36,
  //     "firstROI": 0.57,
  //     "thirdROI": 0.57,
  //     "eighthROI": 0.57,
  //     "fifthROI": 0.57,
  //     "totalROI": 0.57,
  //     "totalRecharge": 7276.73,
  //     "thirdRecharge": 4088.67,
  //     "eighthRecharge": 4088.67,
  //     "fifthRecharge": 4088.67,
  //     "thirtyRecharge": 4088.67,
  //     "sixtyRecharge": 4088.67,
  //     "allRecharge": 4088.67,
  //     "threeTimesGrowth": 1,
  //     "eightTimesGrowth": 1,
  //     "fourthTimesGrowth": 1,
  //     "thirtyTimesGrowth": 1,
  //     "sixtyTimesGrowth": 1,
  //     "gross": null,
  //     "dau": null,
  //     "day1Retention": null,
  //     "day3Retention": null
  // }
  //     ]
  //     this.realData = Array.from({length:33},()=>{
  //       return {...this.realData[0]}
  //     })
  //     this.$set(this.realData[9],'cost',123)
  //     this.$set(this.realData[32],'cost',122223)
  //     this.page.total = this.realData.length
    }
      this.getTable()
      this.showTable=false
    })
  },
  getTable(page){
    if (page) this.page.current = page
    else this.page.current = 1
    
    const tb = cloneDeep(this.realData)
    if(this.orders.order&&this.orders.order!='normal'){
      if(this.orders.order == 'asc'){
        tb.sort((a,b)=>{
          if(typeof a[this.orders.key] == 'string')
          return a[this.orders.key].localeCompare(b[this.orders.key], 'zh-Hans-CN')
          else return a[this.orders.key] - b[this.orders.key]
        })
      }else{
        tb.sort((a,b)=>{
          if(typeof a[this.orders.key] == 'string')return b[this.orders.key].localeCompare(a[this.orders.key], 'zh-Hans-CN')
          else return b[this.orders.key] - a[this.orders.key]
        })
      }
    }
    this.tableData = tb.slice((this.page.current-1)*this.page.size,this.page.current*this.page.size)
    
    
  },
  handleGetDataInit(){
    if(this.channelTag) return
    this.channelTag = true
    getDataInit().then(r=>{
      this.searchOptions = r.data
      this.cloneChannels = r.data.channels||[]
      this.channelTag = false
    })
  },
  handleReset() {
    this.handleGetDataInit()
    this.searchForm = {
      metric: homeData.filter(i=>!i.disabled).map(i=>i.value),
      channel: [],
      adsCampaign: [],
      timeZone: -8
    }
    this.channels = []
    this.campaign = []
    this.getListDate([dayjs().format('YYYY-MM-DD'),dayjs().format('YYYY-MM-DD')])
    this.changeMetric(homeData.filter(i=>!i.disabled))
  }
},
mounted() {
  // this.getData()
  const metric = localStorage.getItem('metric')
  if(!metric){
    this.searchForm.metric = homeData.filter(i=>!i.disabled).map(i=>i.value)
    this.changeMetric(homeData.filter(i=>!i.disabled))
  }else{
    this.searchForm.metric = JSON.parse(metric)
    this.metric = homeData.filter(i=>JSON.parse(metric).indexOf(i.value)>-1)
    
  }
  
  this.handleGetDataInit()
  this.column = this.columns
  this.getListDate([dayjs().format('YYYY-MM-DD'),dayjs().format('YYYY-MM-DD')])
},
activated(){
  this.handleGetDataInit()
}
}
</script>

<style scoped lang="less">
.search-form{
  display:flex;
  flex-wrap: wrap;
  &>*{
      margin: 0 5px 10px;
      
  }
}
.layout-card{
/deep/ .ivu-card-body{
  height: 100%;display:flex;flex-direction: column;
}
}
/deep/.ivu-table td, .ivu-table th{
  height: 20px;
}
/deep/.ivu-table{
  .ivu-table-tbody{
    .ivu-table-row:last-child{
        height: 30px;
        td{
          vertical-align:top;
        height: 30px;
      }
    }
    
  }
}
</style>
